import React, { useState } from 'react';
import { Form, Button, Container, Row, Col, FormCheck } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
import './priceLists.css';

const PriceListsForm = () => {
  const [formData, setFormData] = useState({
    pricelistType: 'procedures',
    includeInactive: false,
    procedure: [],
    attribute: '0',
    groups: [],
    format: ''
  });

  const handleChange = (e) => {
    const { name, value, type, checked, options } = e.target;

    if (type === 'checkbox') {
      setFormData(prevState => ({
        ...prevState,
        [name]: checked
      }));
    } else if (type === 'select-multiple') {
      const selectedOptions = Array.from(options)
        .filter(option => option.selected)
        .map(option => option.value);

      setFormData(prevState => ({
        ...prevState,
        [name]: selectedOptions
      }));
    } else {
      setFormData(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <Container className="my-3 price-lists-container">
      {/* Top Heading */}
      <p className="price-lists-top-heading">
        Price lists by procedure.
      </p>

      {/* Section Heading */}
      <div className="price-lists-section-header">
        <h4 className="price-lists-section-title">
          Parameters
        </h4>
      </div>

      {/* Main Box Container */}
      <div className="price-lists-card-container">
        <Form onSubmit={handleSubmit}>

          {/* Price List Type */}
          <Form.Group
            as={Row}
            controlId="pricelistType"
            className="mb-3 align-items-center"
          >
            <Form.Label column sm="4" className="form-field-label">
              Price List Type
            </Form.Label>

            <Col sm="8" className="form-select-sm-custom">
              <Form.Control
                as="select"
                name="pricelistType"
                value={formData.pricelistType}
                onChange={handleChange}
                className="form-select-input"
              >
                <option value="procedures">Procedures</option>
                <option value="attributes">Attributes</option>
              </Form.Control>
            </Col>
          </Form.Group>

          {/* Procedures Selection & Inactive Checkbox */}
          <Form.Group
            as={Row}
            controlId="procedure"
            className="mb-3"
          >
            <Form.Label
              column
              sm="4"
              className="form-field-label-top"
            >
              Procedures
            </Form.Label>

            <Col sm="8">
              <div className="mb-2">
                <FormCheck
                  type="checkbox"
                  id="includeInactive"
                  name="includeInactive"
                  checked={formData.includeInactive}
                  onChange={handleChange}
                  label="Inactive Selectable?"
                  className="checkbox-text"
                />
              </div>

              <Form.Control
                as="select"
                name="procedure"
                value={formData.procedure}
                onChange={handleChange}
                multiple
                size="10"
                className="procedure-multi-select"
              >
                <option value="404">3D PRINTED MODELS</option>
                <option value="435">3D PRINTED MODEL (HORSE SHOE SHA...</option>
                <option value="60">60% PRECIOUS GOLD CROWN</option>
                <option value="814d">8-14 ALIGNERS (DUAL ARCH)</option>
                <option value="814s">8-14 ALIGNERS (SINGLE ARCH)</option>
                <option value="adin2">ADIN - guided surgery sleeves 2mm</option>
                <option value="adin5">ADIN - guided surgery sleeves 5.5mm</option>
                <option value="alveo">ALVEOPLASTY CLEAR GUIDE</option>
                <option value="anchor">Anchor pin - Surgical Guide</option>
                <option value="anchortwist">Anchor Twist Drill - Surgical guide</option>
              </Form.Control>
            </Col>
          </Form.Group>

          {/* Attribute Selection */}
          {formData.pricelistType === 'attributes' && (
            <Form.Group
              as={Row}
              controlId="attribute"
              className="mb-3 align-items-center"
            >
              <Form.Label
                column
                sm="4"
                className="form-field-label"
              >
                Attribute
              </Form.Label>

              <Col sm="8" className="form-select-sm-custom">
                <Form.Control
                  as="select"
                  name="attribute"
                  value={formData.attribute}
                  onChange={handleChange}
                  className="form-select-input"
                >
                  <option value="0">All</option>
                  <option value="1">Sports Guard Color</option>
                </Form.Control>
              </Col>
            </Form.Group>
          )}

          {/* Pricelist Groups */}
          <Form.Group
            as={Row}
            controlId="groups"
            className="mb-3 align-items-center"
          >
            <Form.Label
              column
              sm="4"
              className="form-field-label"
            >
              Pricelist Groups
            </Form.Label>

            <Col sm="8" className="form-select-sm-custom">
              <Form.Control
                as="select"
                name="groups"
                value={formData.groups}
                onChange={handleChange}
                multiple
                className="form-select-input"
              >
                <option value="">No filter</option>
                <option value="1">1</option>
                <option value="bexley/batt">bexley/batt</option>
                <option value="default">default</option>
              </Form.Control>
            </Col>
          </Form.Group>

          {/* Format Selection */}
          <Form.Group
            as={Row}
            controlId="format"
            className="mb-4 align-items-center"
          >
            <Form.Label
              column
              sm="4"
              className="form-field-label"
            >
              Format <span className="text-danger">*</span>
            </Form.Label>

            <Col sm="8" className="form-select-sm-custom">
              <Form.Control
                as="select"
                name="format"
                value={formData.format}
                onChange={handleChange}
                required
                className="form-select-input"
              >
                <option value="">On Screen</option>
                <option value="csv">CSV (Excel)</option>
              </Form.Control>
            </Col>
          </Form.Group>

          {/* Submit Button */}
          <Form.Group as={Row} className="mb-0">
            <Col sm={{ span: 8, offset: 4 }}>
              <Link
                to="/AddRevenuePrice"
                className="submit-link-wrapper"
              >
                <Button
                  type="submit"
                  className="run-btn-custom"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                  >
                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                  </svg>
                  Run
                </Button>
              </Link>
            </Col>
          </Form.Group>

        </Form>
      </div>
    </Container>
  );
};

export default PriceListsForm;